import React, { useState, useEffect, useRef } from "react";
import "./NewsSection.css";
import { FaChevronRight, FaChevronLeft, FaTimes, FaRegCalendarAlt } from "react-icons/fa";
import { createPortal } from "react-dom";

import kamp1 from "../haberler/zeze-kampi-2026/kamp-01.jpeg";
import kamp2 from "../haberler/zeze-kampi-2026/kamp-02.jpeg";
import kamp3 from "../haberler/zeze-kampi-2026/kamp-03.jpeg";
import kamp4 from "../haberler/zeze-kampi-2026/kamp-04.jpeg";
import kamp5 from "../haberler/zeze-kampi-2026/kamp-05.jpeg";
import kamp6 from "../haberler/zeze-kampi-2026/kamp-06.jpeg";
import kamp7 from "../haberler/zeze-kampi-2026/kamp-07.jpeg";
import kamp8 from "../haberler/zeze-kampi-2026/kamp-08.jpeg";
import kamp9 from "../haberler/zeze-kampi-2026/kamp-09.jpeg";
import kamp10 from "../haberler/zeze-kampi-2026/kamp-10.jpeg";
import kamp11 from "../haberler/zeze-kampi-2026/kamp-11.jpeg";
import kamp12 from "../haberler/zeze-kampi-2026/kamp-12.jpeg";
import kamp13 from "../haberler/zeze-kampi-2026/kamp-13.jpeg";
import kamp14 from "../haberler/zeze-kampi-2026/kamp-14.jpeg";
import kamp15 from "../haberler/zeze-kampi-2026/kamp-15.jpeg";

import festival1 from "../haberler/zeze-festivali-2026/festival-01.jpeg";
import festival2 from "../haberler/zeze-festivali-2026/festival-02.jpeg";
import festival3 from "../haberler/zeze-festivali-2026/festival-03.jpeg";
import festival4 from "../haberler/zeze-festivali-2026/festival-04.jpeg";
import festival5 from "../haberler/zeze-festivali-2026/festival-05.jpeg";
import festival6 from "../haberler/zeze-festivali-2026/festival-06.jpeg";
import festival7 from "../haberler/zeze-festivali-2026/festival-07.jpeg";
import festival8 from "../haberler/zeze-festivali-2026/festival-08.jpeg";
import festival9 from "../haberler/zeze-festivali-2026/festival-09.jpeg";
import festival10 from "../haberler/zeze-festivali-2026/festival-10.jpeg";
import festival11 from "../haberler/zeze-festivali-2026/festival-11.jpeg";
import festival12 from "../haberler/zeze-festivali-2026/festival-12.jpeg";
import festival13 from "../haberler/zeze-festivali-2026/festival-13.jpeg";
import festival14 from "../haberler/zeze-festivali-2026/festival-14.jpeg";
import festival15 from "../haberler/zeze-festivali-2026/festival-15.jpeg";
import festival16 from "../haberler/zeze-festivali-2026/festival-16.jpeg";

import yv1 from "../haberler/yv1.png";
import yv2 from "../haberler/yv2.png";
import yv3 from "../haberler/yv3.png";
import yv4 from "../haberler/yv4.png";
import yv5 from "../haberler/yv5.png";
import yv6 from "../haberler/yv6.png";
import yv7 from "../haberler/yv7.png";
import kasim13_1 from "../haberler/13kasim1.png";
import kasim13_2 from "../haberler/13kasim2.png";
import kasim13_3 from "../haberler/13kasim3.png";
import kasim13_4 from "../haberler/13kasim4.png";
import kasim13_5 from "../haberler/13kasim5.png";
import yerli1 from "../haberler/yerli1.png";
import yerli2 from "../haberler/yerli2.png";
import su from "../haberler/su.png";

function PhotoSlider({ images, title }) {
  const [photoIndex, setPhotoIndex] = useState(0);
  const startX = useRef(null);
  const move = (step) => setPhotoIndex((current) => (current + step + images.length) % images.length);

  return (
    <div className="news-photo-slider"
      onMouseDown={(event) => event.stopPropagation()}
      onTouchStart={(event) => { event.stopPropagation(); startX.current = event.touches[0].clientX; }}
      onTouchMove={(event) => event.stopPropagation()}
      onTouchEnd={(event) => {
        event.stopPropagation();
        if (startX.current !== null) {
          const distance = event.changedTouches[0].clientX - startX.current;
          if (Math.abs(distance) > 40) move(distance > 0 ? -1 : 1);
        }
        startX.current = null;
      }}
    >
      <img src={images[photoIndex]} alt={`${title} — Fotoğraf ${photoIndex + 1}`} loading="lazy" />
      {images.length > 1 && <>
        <button type="button" className="photo-arrow photo-prev" aria-label="Önceki fotoğraf" onClick={() => move(-1)}><FaChevronLeft /></button>
        <button type="button" className="photo-arrow photo-next" aria-label="Sonraki fotoğraf" onClick={() => move(1)}><FaChevronRight /></button>
        <span className="photo-counter" aria-live="polite">{photoIndex + 1} / {images.length}</span>
      </>}
    </div>
  );
}

// 🔹 Tekil Slider Bileşeni
function Slider({ title, subtitle, color, bgColor, items }) {
  const [index, setIndex] = useState(0);
  const [selected, setSelected] = useState(null);
  const [paused, setPaused] = useState(false);
  const slideCount = items.length;
  const autoplayRef = useRef(null);
  const dialogRef = useRef(null);

  useEffect(() => {
    if (!selected) return;
    const previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialogRef.current?.querySelector('button')?.focus();
    const onKeyDown = (event) => {
      if (event.key === 'Escape') setSelected(null);
      if (event.key === 'Tab') {
        const controls = dialogRef.current?.querySelectorAll('button, a[href], video[controls], [tabindex="0"]');
        if (!controls?.length) return;
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      }
    };
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', onKeyDown);
      previousFocus?.focus();
    };
  }, [selected]);
  const trackRef = useRef(null);
  const touch = useRef({ active: false, startX: 0, currentX: 0 });

  useEffect(() => {
    if (!selected && !paused) startAutoplay();
    return () => stopAutoplay();
  }, [index, paused, selected]);

  const startAutoplay = () => {
    stopAutoplay();
    if (paused || slideCount < 2) return;
    autoplayRef.current = setInterval(() => {
      setIndex((i) => (i + 1) % slideCount);
    }, 4000);
  };

  const stopAutoplay = () => {
    if (autoplayRef.current) {
      clearInterval(autoplayRef.current);
      autoplayRef.current = null;
    }
  };

  const goPrev = () => {
    setIndex((i) => (i - 1 + slideCount) % slideCount);
    pauseTemporary();
  };

  const goNext = () => {
    setIndex((i) => (i + 1) % slideCount);
    pauseTemporary();
  };

  const goTo = (i) => {
    setIndex(i);
    pauseTemporary();
  };

  const pauseTemporary = () => {
    setPaused(true);
    stopAutoplay();
    setTimeout(() => setPaused(false), 2000);
  };

  // Dokunmatik kaydırma
  const onPointerDown = (e) => {
    const x = e.touches ? e.touches[0].clientX : e.clientX;
    touch.current = { active: true, startX: x, currentX: x };
    setPaused(true);
    stopAutoplay();
    if (trackRef.current) trackRef.current.style.transition = "none";
  };

  const onPointerMove = (e) => {
    if (!touch.current.active) return;
    const x = e.touches ? e.touches[0].clientX : e.clientX;
    touch.current.currentX = x;
    const dx = x - touch.current.startX;
    if (trackRef.current)
      trackRef.current.style.transform = `translateX(calc(-${index * 100}% + ${dx}px))`;
  };

  const onPointerUp = () => {
    if (!touch.current.active) return;
    touch.current.active = false;
    const dx = touch.current.currentX - touch.current.startX;
    const threshold = 60;
    if (trackRef.current)
      trackRef.current.style.transition = "transform 0.6s cubic-bezier(.22,.9,.3,1)";
    if (dx > threshold) goPrev();
    else if (dx < -threshold) goNext();
    else if (trackRef.current)
      trackRef.current.style.transform = `translateX(-${index * 100}%)`;
    setTimeout(() => {
      setPaused(false);
      startAutoplay();
    }, 2500);
  };

  return (
    <div
      className={`news-section ${color === "#f97316" ? "news-orange" : "news-green"}`}
      style={{ backgroundColor: bgColor }}
    >
      {/* 🔹 Başlık */}
      <header className="news-header">
        <h2 style={{ color }}>{title}</h2>
      </header>
      <p className="lead">{subtitle}</p>

      {/* 🔹 Slider */}
      <div className="slider-wrap">
        <button className="slider-arrow left" onClick={goPrev} hidden={slideCount < 2}>
          <FaChevronLeft />
        </button>

        <div
          className="slider-viewport"
          onTouchStart={onPointerDown}
          onTouchMove={onPointerMove}
          onTouchEnd={onPointerUp}
          onMouseDown={(e) => {
            e.preventDefault();
            onPointerDown(e);
          }}
          onMouseMove={(e) => {
            if (touch.current.active) onPointerMove(e);
          }}
          onMouseUp={onPointerUp}
          onMouseLeave={onPointerUp}
        >
          <div
            className="slider-track"
            ref={trackRef}
            style={{ transform: `translateX(-${index * 100}%)` }}
          >
            {items.map((item) => (
              <article className="slide" key={item.id}>
                {(item.img || item.images) && <div className="slide-img">
                  {item.images ? <PhotoSlider images={item.images} title={item.title} /> : <img src={item.img} alt={item.title} loading="lazy" />}
                </div>}
                <div className="slide-body">
                  <time className="news-date">{item.date}</time>
                  <h3 className="news-title">{item.title}</h3>
                  <p className="news-excerpt">{item.excerpt}</p>

                  <button
                    className="btn-read"
                    onClick={() => {
                      setSelected(item);
                      stopAutoplay();
                    }}
                  >
                    Devamını Oku <FaChevronRight />
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>

        <button className="slider-arrow right" onClick={goNext} hidden={slideCount < 2}>
          <FaChevronRight />
        </button>
      </div>

      {/* 🔹 Dot Göstergeleri */}
      <div className="slider-dots" style={slideCount < 2 ? { display: "none" } : undefined}>
        {items.map((_, i) => (
          <button
            key={i}
            className={`dot ${i === index ? "active" : ""}`}
            onClick={() => goTo(i)}
          />
        ))}
      </div>

      {/* 🔹 Modal - Body üzerinde tam ekran */}
      {selected &&
        createPortal(
          <div className="news-modal" style={{ "--news-accent": color }}>
            <div
              className="news-modal-backdrop"
              onClick={() => {
                setSelected(null);
                startAutoplay();
              }}
            />

            <div className="news-modal-inner" ref={dialogRef} role="dialog" aria-modal="true" aria-label={selected.title}>
              <div className="news-modal-topbar">
                <span className="news-modal-category">{title}</span>
              <button
                className="modal-close"
                aria-label="Haberi kapat"
                onClick={() => {
                  setSelected(null);
                  startAutoplay();
                }}
              >
                <FaTimes />
              </button>
              </div>

              {/* 🔸 Görseller veya Video */}
              {(selected.video || selected.images || selected.img) && <div className="modal-img">
                {selected.video ? (
                  <video
                    src={selected.video}
                    controls
                    autoPlay
                    style={{
                      width: "100%",
                      borderRadius: "12px",
                      marginTop: "10px",
                      maxHeight: "70vh",
                    }}
                  />
                ) : selected.images ? (
                  <PhotoSlider key={selected.id} images={selected.images} title={selected.title} />
                ) : (
                  <img src={selected.img} alt={selected.title} />
                )}
              </div>}

              <div className="modal-content">
                <div className="news-modal-meta">
                  <time className="news-modal-date"><FaRegCalendarAlt aria-hidden="true" />{selected.date}</time>
                  {selected.images && <span>{selected.images.length} fotoğraf</span>}
                </div>
                <h2>{selected.title}</h2>
                <div className="news-article-text">
                  {selected.content.split(/\n\s*\n/).map((paragraph, i) => <p key={i}>{paragraph}</p>)}
                </div>
                <footer className="news-modal-footer">Yeldeğirmeni Eğitim Kurumları</footer>
              </div>
            </div>
          </div>,
          document.body
        )}
    </div>
  );
}

// Ana Bölüm
export default function NewsSection() {
  const festivalNews = [
    {
      id: 'zeze-ilkokul-kampi-2026',
      images: [kamp1, kamp2, kamp3, kamp4, kamp5, kamp6, kamp7, kamp8, kamp9, kamp10, kamp11, kamp12, kamp13, kamp14, kamp15],
      title: 'Zeze’nin Bahçesi’nde Geleneksel İlkokul Kampımız',
      date: '2 Ekim 2026',
      excerpt: 'İlkokul öğrencilerimizle Zeze’nin Bahçesi’nde çadırlar kurduk, şarkılar söyledik ve açık hava sinemasıyla dolu dolu bir kamp akşamı geçirdik.',
      content: `Her yıl tüm okulumuzla birlikte geleneksel olarak Zeze’nin bahçesinde gerçekleştirdiğimiz kampımızı bu yıl da 2 Ekim Cuma günü ilkokul öğrencilerimizle yaşadık. Çadırlar kuruldu, ateşler yakıldı, şarkılar söylendi ve açık hava sinemasıyla dolu dolu bir akşam geçirildi.

Bu kamp, çocuklarımızın özgüvenlerini pekiştirirken aynı zamanda aidiyet duygusunu güçlendirdi. Doğayla iç içe geçirilen bu özel deneyim, onların motivasyonunu artırarak hem eğlenceli bir hatıra hem de yaşam becerisi kazandıran bir fırsat sundu.`,
    },
    {
      id: 'zeze-cocuk-festivali-2026',
      title: 'Zeze Çocuk Festivali 2026',
      date: '19–20 Eylül 2026',
      excerpt: "Yeldeğirmeni Eğitim Kurumları ve Zeze'nin Bahçesi olarak, Zeze Çocuk Festivali 2026 kapsamında çocuklarımızla birlikte keyifli ve unutulmaz anlar yaşadık.",
      content: `Yeldeğirmeni Eğitim Kurumları ve Zeze'nin Bahçesi olarak, Zeze Çocuk Festivali 2026 kapsamında çocuklarımızla birlikte keyifli ve unutulmaz anlar yaşadık.
Zeze’nin Bahçesi’nde organize edilen festival, birbirinden eğlenceli etkinlikleriyle çocuklara neşe dolu bir gün sundu.

Festival kapsamında sahne alan Onur Erol, sevilen performansıyla çocuklarla buluşurken tiyatro gösterisi ve büyüleyici Bubble Show katılımcılara eğlence dolu anlar yaşattı.

Çocukların hayal dünyasını zenginleştiren, sanatı ve eğlenceyi bir araya getiren bu özel etkinlikte emeği geçen herkese teşekkür ediyor; çocuklarımızın mutluluğunu paylaşmaktan büyük mutluluk duyuyoruz.`,
      images: [festival1, festival2, festival3, festival4, festival5, festival6, festival7, festival8, festival9, festival10, festival11, festival12, festival13, festival14, festival15, festival16],
    },
  ];

  const greenVatanNews = [
    {
      id: 'yesil-vatan-tatbikat',
      title: '“Yeşil Vatan - Benim Okulum Geleceğe Çare”',
      date: '4 Kasım 2025',
      excerpt: 'Millî Eğitim Bakanlığı tarafından yürütülen “Yeşil Vatan - Benim Okulum Geleceğe Çare” projesi etkinlikleri kapsamında, 2025-2026 eğitim öğretim yılı tematik takviminde Ekim ayı “Afetler ve Dayanıklılık Ayı” olarak belirlendi.',
      content: 'Millî Eğitim Bakanlığı tarafından yürütülen “Yeşil Vatan - Benim Okulum Geleceğe Çare” projesi etkinlikleri kapsamında, 2025-2026 eğitim öğretim yılı tematik takviminde Ekim ayı “Afetler ve Dayanıklılık Ayı” olarak belirlendi. Afetler ve Dayanıklılık Ayı çerçevesinde, tüm okullarla eş zamanlı olarak okulumuzda ögrencilerimize Depreme karşı korunma yolları ile ilgili bilgiler aktarıldıktan sonra tatbikat uyguladık. Afetlere karşı farkındalık arttırıcı bir eğitim oldu.',
      images: [yv1, yv2, yv3, yv4, yv5, yv6, yv7],
    },
    {
      id: 'fidan',
      title: 'Bugün öğrencilerimizle birlikte doğaya minik bir hediye verdik 🌳',
      date: '13 Kasım 2025',
      excerpt: 'Her bir fidan, çocuklarımızın elleriyle toprağa kavuştu.',
      content: 'Bugün öğrencilerimizle birlikte doğaya minik bir hediye verdik 🌳 Her bir fidan, çocuklarımızın elleriyle toprağa kavuştu. Geleceğe nefes, çocuklarımıza umut olsun! 💚',
      images: [kasim13_1, kasim13_2, kasim13_3, kasim13_4, kasim13_5],
    },
    {
      id: 'yerli-mali',
      title: '🇹🇷 Yerli Malı, Yurdun Malı… Herkes Onu Kullanmalı!',
      date: '22 Aralık 2025',
      excerpt: 'Okulumuzda düzenlediğimiz Yerli Malı haftasını öğrencilerimiz ile kutladık.',
      content: 'Okulumuzda düzenlediğimiz Yerli Malı Gösterisi ile öğrencilerimiz; yerli üretimin değerini, paylaşmayı, kendi kültürümüzle gurur duymayı sahneye taşıdı. Minik yüreklerin büyük emekleriyle hazırlanan bu gösteri, hem izleyenleri gülümsetti hem de yerli üretimin önemini bir kez daha hatırlattı.',
      images: [yerli1, yerli2],
    },
    {
      id: 'su',
      title: '💧Her damla değerli!',
      date: '26 Aralık 2025',
      excerpt: 'Su tasarrufu ile geleceğimizi koruyalım🌎',
      content: '💧Her damla değerli! Okulumuz öğrencileri için daha bilinçli tüketimi sağlamak ve su tasarrufunun önemi anlatmak için ASKİ den mühendis misafirlerimiz geldi. Suyun hayatımızdaki önemi ve hayatımızda olmazsa neler olabileceği hakkında farkındalık sunumumuz gerçekleşti. Su tasarrufu ile geleceğimizi koruyalım 🌎',
      images: [su],
    },
  ];

  return (
    <section className="split-section">
      <div className="column-wrapper">
        <Slider
          title="Yeldeğirmeni'nden Haberler"
          subtitle="Okuldan güncellemeler, atölye ve etkinliklerden haberler."
          color="#f97316"
          bgColor="#fff4e8"
          items={festivalNews}
        />
      </div>
      <div className="column-wrapper">
        <Slider title="Yeşil Vatan 💚 " subtitle="Doğa, çevre ve sürdürülebilirlik üzerine çalışmalarımız."
          color="#10b981" bgColor="#e9f9ef" items={greenVatanNews} />
      </div>
    </section>
  );
}
